import { Routes, Route, Navigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { StaffSidebar } from "../../Sidebar/staff-sidebar";
import MyProfile from "../Teacher/MyProfile";
import StaffLeaveApplication from "../Staff/Staff-leave-application";

export default function StaffDashboardRouter() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(false);
  }, []);

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500" />
        <span className="ml-2">Loading...</span>
      </div>
    );
  }

  return (
    <Routes>
      <Route path="/" element={<StaffSidebar />}>
        <Route index element={<Navigate to="/dashboard/profile" replace />} />
        <Route path="profile" element={<MyProfile />} />
        <Route path="leave" element={<StaffLeaveApplication />} />
        <Route path="*" element={<Navigate to="/dashboard/profile" replace />} />
      </Route>
    </Routes>
  );
}
